/**
 * Bolas que sueltan los enemigos al morir — lógica pura, sin Phaser. A más
 * vida máxima, más bolas; los jefes son proporcionalmente más generosos
 * (piso y techo más altos) para compensar que son un enemigo único por
 * oleada en vez de un grupo.
 */

/** Bolas que suelta un enemigo común según su vida máxima. */
export function ballsDropped(maxHp: number): number {
  return Math.min(9, Math.max(1, Math.round(maxHp / 20)));
}

/** Bolas que suelta un jefe: cosecha grande, con piso y techo más altos. */
export function bossBallsDropped(maxHp: number): number {
  return Math.min(30, Math.max(8, Math.round(maxHp / 12)));
}
